"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ButtonIcon = _interopRequireDefault(require("../../ButtonIcon"));

var _colors = require("../../../styles/colors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    &[disabled] {\n        background-color: ", ";\n\n        > svg {\n            fill: ", ";\n        }\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledButtonIcon = (0, _styledComponents["default"])(_ButtonIcon["default"])(_templateObject(), _colors.COLOR_WHITE, _colors.COLOR_GRAY_2);
var _default = StyledButtonIcon;
exports["default"] = _default;